<template>
  <div>
    <div v-if="ownerNameInitial"
         class="flex items-center border justify-center rounded-full w-7 h-7 hover:border-red-500"
         :title="ownerNameParsed"
         style="color:#FFFFFF"
         :style="{ backgroundColor: backgroundColor}"
         @click="openUpdateOwnerForm"
    >
      <span class="font-bold">
        {{ownerNameInitial}}
      </span>
    </div>
  </div>
</template>

<script>


import {generateSimilarColor} from '@/utils/common';

export default {
  props: {
    ownerId:{
      type:Number,
    },
    ownerType:{
      type:String
    },
    ownerName:{
      type:String
    },
    ownerColor:{
      type:String
    },
    appUserRoleId:{
      type:Number
    },
    objectContentTypeModel:{
      type:String,
      required:true
    },
    objectId:{
      type:Number,
      required:true
    }
  },
  data() {
    return {};
  },
  computed:{
    ownerNameParsed(){
      if(this.ownerType==='appuser'){
        return this.ownerName
      }
      else if(this.ownerType==='practice'){
        return 'Practice'
      }
      else{
        return ''
      }
    },
    ownerNameInitial(){
      if(this.ownerType==='appuser'){
        if(!this.ownerName) return ''
        const parts = this.ownerName.trim().split(/\s+/)
        const first_initial = parts[0]?.charAt(0) || ''
        const second_initial = parts[1]?.charAt(0) || ''
        const initials = (first_initial + second_initial).toUpperCase()
        return initials
      }
      else if(this.ownerType==='practice'){
        return 'P'
      }
      else{
        return ''
      }
    },
    backgroundColor(){
      if(this.ownerType==='appuser'){
        return generateSimilarColor(this.ownerColor,0.0,-50.0)
      }
      else{
        return '#dddddd'
      }
    },
  },
  methods: {
    openUpdateOwnerForm(){
      this.$emit('update-owner', {
        ownerId: this.ownerId,
        objectContentTypeModel: this.objectContentTypeModel,
        objectId: this.objectId
      });
    }
  },
}
</script>
